import { CButton } from "@coreui/react";
import React from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import Auth from "src/auth";

const LotListViewDownloadAgreementAndTransferLetter = (props) => {
  const { authenticated } = Auth();

  const DownloadTransferLetter = async (lotid) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadTransferLetter?lotid=${Number(lotid)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = lotid + "_" + authenticated.userId + ".pdf";
        alink.click();
      });
    }
  };

  const handleDownloadAgreementLetter = async (tenderid, lotid, userid) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadAgreementLetter?tenderId=${Number(
        tenderid
      )}&lotid=${lotid}&userid=${Number(userid)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = lotid + "_Bidder" + userid + "_Original.pdf";
        alink.click();
      });
    }
  };

  return (
    <>
      {/* {"hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"} -{" "}
            {props.viewTransferDetails.length} -
            {props.viewTenderDetails?.isAgreementLetterGenerated
              ? "generated"
              : "not generated"}{" "}
            -{props.viewListDetails.isAgreementAccepted}-
            {props.viewListDetails.  ? "true" : "false"} -
            {props.viewListDetails.isSanctionAccepted} -
            {props.EmdPaid.isEMDPaid ? "EMD Paid" : "EMD Not Paid"} -
            {props.viewListDetails.emdChequeNo} - {props.viewListDetails.emdStatusCode}-{" "}
            {props.viewListDetails.disableEMDPayment
              ? "disable EMD Payment"
              : "Not disable EMD payment"} */}
      <div className="row">
        <div className="col-xl-12">
          {props.viewListDetails &&
          (props.EmdPaid.isEMDPaid === true ||
            (props.viewListDetails.emdChequeNo !== "" &&
              props.viewListDetails.emdStatusCode === "Success" &&
              !props.viewListDetails.disableEMDPayment)) &&
          props.viewTenderDetails &&
          authenticated.role === "Bidder" &&
          props.viewTenderDetails?.isSanctionLetterGenerated &&
          props.viewListDetails.isSanctionAccepted === 1 &&
          props.viewTenderDetails?.isAgreementLetterGenerated &&
          props.viewListDetails.isAgreementAccepted === 1 &&
          props.viewTransferDetails.length === 0 ? (
            <>
              {/* <a
                      href={`${downloadUrl}/${props.viewListDetails?.agreementLetterPath}`}
                      target="_blank"
                      className=""
                      rel="noreferrer"
                    >
                      <CButton
                        className="mt-1 mr-2"
                        color="success"
                        hidden="true"
                      >
                        View Agreement Letter
                      </CButton>
                    </a> */}
              <CButton
                className="mt-1 mr-2"
                color="success"
                variant="outline"
                onClick={() =>
                  handleDownloadAgreementLetter(
                    props.viewListDetails.tenderId,
                    props.viewListDetails.lotId,
                    props.viewListDetails.userId
                  )
                }
              >
                Download Agreement Letter
              </CButton>

              {/* <CButton
                      className="mt-1"
                      color="success"
                      variant="outline"
                      hidden="true"
                      onClick={() => updateAgreement(1)}
                    >
                      Accept Agreement
                    </CButton>
                    <CButton
                      className="mt-1 ml-2 mr-2"
                      color="danger"
                      variant="outline"
                      hidden="true"
                      onClick={() => updateAgreement(2)}
                    >
                      Reject Agreement
                    </CButton> */}
            </>
          ) : authenticated.role === "Bidder" &&
            props.viewTenderDetails?.isSanctionLetterGenerated &&
            props.viewListDetails.isSanctionAccepted === 1 &&
            props.viewTenderDetails?.isAgreementLetterGenerated &&
            ((props.viewListDetails.lotTransferCount === 1 &&
              props.viewListDetails.isTransferLotEMDPaid === true) ||
              (props.viewListDetails.lotTransferCount === 2 &&
            props.viewListDetails.isTransferFeePaidStatusSuccess === true)) &&
            props.viewTransferDetails.length > 0 ? (
            // viewPaymentDetails[viewPaymentDetails.length - 1]?.paidByUser !== null
            <>
              {/* <a
                      href={`${apiCall.downloadUrl}/${props.viewListDetails?.agreementLetterPath}`}
                      target="_blank"
                      className=""
                      rel="noreferrer"
                    >
                      <CButton
                        className="mt-5 mr-2"
                        color="success"
                        hidden="true"
                      >
                        View Agreement Letter
                      </CButton>
                    </a> */}
              <CButton
                className="mt-1 ml-2 mr-2"
                color="success"
                variant="outline"
                onClick={() =>
                  handleDownloadAgreementLetter(
                    props.viewListDetails.tenderId,
                    props.viewListDetails.lotId,
                    props.viewListDetails.userId
                  )
                }
              >
                Download Agreement Letter
              </CButton>

              {/* <CButton
                      className="mt-1"
                      color="success"
                      variant="outline"
                      hidden="true"
                      onClick={() => updateAgreement(1)}
                    >
                      Accept Agreement
                    </CButton>
                    <CButton
                      className="mt-5 ml-2 mr-2"
                      color="danger"
                      variant="outline"
                      hidden="true"
                      onClick={() => updateAgreement(2)}
                    >
                      Reject Agreement
                    </CButton> */}
            </>
          ) : (
            ""
          )}
          {props.viewListDetails.isTransferLatterGenerated &&
          props.viewListDetails.islottransferd === 1 ? (
            <CButton
              className="mt-1 ml-2 mr-2"
              color="success"
              variant="outline"
          onClick={() => DownloadTransferLetter(props.viewListDetails.lotId)}
            >
              Download Transfer Latter
            </CButton>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default LotListViewDownloadAgreementAndTransferLetter;
